import React, { useMemo } from 'react';

import { Badge, Body, Caption, CheckboxInputWithLabel } from '@meterup/atto';
import { Quote } from '@meterup/connect-api';
import { FormattedQuoteMonthlyAmountSimple } from '@meterup/connect-ui/src/FormattedMonthlyAmount/FormattedMonthlyAmount';

// Props will be a bunch of onchangeevent
interface FilterProvidersProps {
  allProviders: string[];
  currentProviders: string[];
  onProvidersChange: (providerName: string, checked: boolean) => void;
  quotesByProvider: { [provider: string]: Quote[] };
}

function FilterProviders({
  allProviders,
  currentProviders,
  onProvidersChange,
  quotesByProvider,
}: FilterProvidersProps) {
  const providersSorted = useMemo(
    () =>
      allProviders.reduce<{ providerName: string; preferred: boolean }[]>((acc, providerName) => {
        const isPreferred = (quotesByProvider[providerName] || []).some((q) => q.isPreferred);
        if (isPreferred) {
          acc.unshift({ providerName, preferred: true });
        } else {
          acc.push({ providerName, preferred: false });
        }
        return acc;
      }, []),
    [allProviders, quotesByProvider],
  );

  return (
    <section>
      <Caption>Providers</Caption>
      <div className="mt-2">
        {providersSorted.map(({ providerName, preferred }) => (
          <div className="mt-2" key={providerName}>
            <CheckboxInputWithLabel
              checked={currentProviders.includes(providerName)}
              onChange={(checked: boolean) => onProvidersChange(providerName, checked)}
              aria-label={`Choose provider ${providerName}`}
              name={`providerName-${providerName}`}
            >
              <div
                className="w-full flex justify-between"
                onClick={() =>
                  onProvidersChange(providerName, !currentProviders.includes(providerName))
                }
              >
                <div className="flex items-center gap-2">
                  <Body weight="bold">{providerName}</Body>
                  {preferred && (
                    <Body>
                      <Badge variant="brand" size="small">
                        Preferred
                      </Badge>
                    </Body>
                  )}
                </div>
                <Body>
                  <FormattedQuoteMonthlyAmountSimple quote={quotesByProvider[providerName][0]} />
                </Body>
              </div>
            </CheckboxInputWithLabel>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FilterProviders;
